import 'twin.macro';
import 'styled-components/macro';

import { useOnClickOutside, useOnEscapeKeyDown } from 'support/react/hooks';

import { UserProfile, UserProfileProps } from './account/UserProfile';
import { LoggedInMenu } from './LoggedInMenu';
import { LoggedOutMenu } from './LoggedOutMenu';

export interface NavigationMenuProps extends React.HTMLAttributes<HTMLElement> {
  teamSlug?: string;
  onClose: () => void;
  onLogout?: () => void;
  profile?: UserProfileProps['profile'];
  shouldHideAccountActions?: boolean;
  shouldHideContent?: boolean;
  shouldHideInspirationLibrary?: boolean;
  showAdminMenuEntry?: boolean;
  showDocumentationMenuEntry?: boolean;
}

export const NavigationMenu = ({
  teamSlug,
  onClose,
  onLogout,
  profile,
  shouldHideAccountActions,
  shouldHideContent,
  shouldHideInspirationLibrary,
  showAdminMenuEntry,
  showDocumentationMenuEntry,
}: NavigationMenuProps) => {
  const { ref } = useOnClickOutside<HTMLDivElement>(onClose);
  useOnEscapeKeyDown(onClose);

  return (
    <div
      tw="relative z-overlay overflow-y-auto overflow-x-hidden bg-white p-4 sm:(rounded-2xl shadow-md w-42 h-auto absolute right-0 top-0 mr-4)"
      ref={ref}
      css={`
        height: calc(100vh - 81px);
        @media (min-width: 768px) {
          height: auto;
          margin-top: calc(88px - 0.5rem);
          max-height: calc(100vh - 72px);
        }
      `}
    >
      {profile ? (
        <>
          <UserProfile profile={profile} />
          <hr tw="border-gray-15 my-3" />
          <LoggedInMenu
            teamSlug={teamSlug}
            shouldHideContent={shouldHideContent}
            shouldHideInspirationLibrary={shouldHideInspirationLibrary}
            showAdminMenuEntry={showAdminMenuEntry}
            showDocumentationMenuEntry={showDocumentationMenuEntry}
            onLogout={onLogout}
          />
        </>
      ) : (
        <LoggedOutMenu shouldHideAccountActions={shouldHideAccountActions} />
      )}
    </div>
  );
};
